



@if (isLoading) {
  <!-- Skeleton loading UI -->
  <div class="main-payrol-detail skeleton-main skeleton">
    <div class="payroll-subcomponent">
      <div class="common-head">
        <div class="skeleton-box title"></div>
        <div class="skeleton-box button-group"></div>
      </div>

      <div class="table-container">
        <div class="skeleton-table">
          <div class="skeleton-row header"></div>
          <div class="skeleton-row"></div>
          <div class="skeleton-row"></div>
          <div class="skeleton-row"></div>
          <div class="skeleton-row"></div>
          <div class="skeleton-row"></div>
          <div class="skeleton-row"></div>
          <div class="skeleton-row"></div>

        </div>
      </div>
    </div>

    <div class="latest-payoll-section">
      <div class="skeleton-card"></div>
      <div class="skeleton-card"></div>
    </div>
  </div>
} @else {
<div class="main-payrol-detail">
    <div class="payroll-subcomponent">
    <div class="common-head">
       <div class="comon-left-head borderless">
         <h1>Pay Roll</h1>
       </div>
       <div class="comon-right">
            <div class="view-all" (click)="goToPayrollList()">
                View all
            </div>
            <div class="request-loan" (click)="loanreq()">
                Request Loan
            </div>
       </div>
    </div>
    
    <div class="table-container">
        <table class="responsive-table">
            <thead>
            <tr>
                <th>Year</th>
                <th>Month</th>
                <th>Realease Date</th>
                <th>Total</th>
                <th>Deduction</th>
                <th>Recieved</th>
                <th>Action</th>
            </tr>
            </thead>
            <tbody>
                 @for (item of salaries; track item.id) {
            <tr>
              <td>{{ item.month_year }}</td>
              <td>{{ item.month_char }}</td>
              <td>{{ item.salary_released_date | date:'dd-MM-yyyy' }}</td>

              <!-- Gross Salary -->
              <td>
                @if (isStar) {
                  *****/- PKR
                } @else {
                  {{item.basic_salary === null ? "00" : item.basic_salary }}/- PKR
                  
                }
              </td>

              <!-- Tax -->
              <td>
                @if (isStar) {
                  *****/- PKR
                } @else {
                  {{item.total_deduction === null ? "00" : item.total_deduction}}/- PKR
                }
              </td>

              <!-- Net Salary -->
              <td>
                @if (isStar) {
                  *****/- PKR
                } @else {
                  {{item.released_salary === null ? "00" : item.released_salary }}/- PKR
                }
              </td>

              <td>
                <div class="active-button" (click)="showSlip(item)">
                  <img src="../../../../assets/theme1/eye.png" alt="eye icon" />
                  View
                </div>
              </td>
            </tr>
          }
            </tbody>
        </table>
    </div>
   
    
</div>

    <div class="latest-payoll-section">
        <div class="payrol-deduct-sec">
            <div class="common-head">
                <div class="comon-left-head border-reduce">
                    <h1>Latest Payroll</h1>
                </div>
                <div class="comon-right allocation-date">
                    <p>{{ lastSalary.salary_released_date | date:'dd MMMM yyyy' }}</p>
                </div>   
            </div>
            <div class="pay-roll-inner-sec">
                <div class="payrol-comon">
                    <div class="payrol-icon">
                        <img src="../../../../assets/theme1/dolar.png" alt="missing icon"/>
                    </div>
                    <div class="payrol-amount">
                        <p>Total Salary</p>
                        <h1>
                            
                             @if (isStar) {
                                *****
                                } @else {
                                {{lastSalary.basic_salary === null ? "00" : lastSalary.basic_salary }}
                                }
                            <span>/- PKR</span></h1>
                    </div>
                </div>
                 <div class="payrol-comon">
                    <div class="payrol-icon">
                        <img src="../../../../assets/theme1/recieved.png" alt="missing icon"/>
                    </div>
                    <div class="payrol-amount">
                        <p>Received Salary</p>
                        <h1>
                             @if (isStar) {
                                *****
                                } @else {
                                {{lastSalary.released_salary === null ? "00" : lastSalary.released_salary }}
                                }
                            
                            <span>/- PKR</span></h1>
                    </div>
                </div>
            </div>
               <div class="pay-roll-inner-sec border-finish pb-0">
                <div class="payrol-comon">
                    <div class="payrol-icon">
                        <img src="../../../../assets/theme1/deduct.png" alt="missing icon"/>
                    </div>
                    <div class="payrol-amount">
                        <p>Deduction</p>
                        <h1>
                              @if (isStar) {
                                *****/- PKR
                                } @else {
                                {{lastSalary.total_deduction === null ? "00" : lastSalary.total_deduction}}
                                }
                            <span>/- PKR</span></h1>
                    </div>
                </div>
                 <div class="payrol-comon">
                    <div class="payrol-icon">
                        <img src="../../../../assets/theme1/tax.png" alt="missing icon"/>
                    </div>
                    <div class="payrol-amount">
                        <p>Tax</p>
                        <h1>
                             @if (isStar) {
                                *****/- PKR
                                } @else {
                                {{lastSalary.tax === null ? "00" : lastSalary.tax}}
                                }
                                <span>/- PKR</span></h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="upcoming-payrol">
            <div class="common-head">
                <div class="comon-left-head border-reduce">
                    <h1>Upcoming Payroll</h1>
                </div>
                <div class="comon-right allocation-date">
                        <p>{{userSalaryUpcoming.month}}</p>
                </div>   
            </div>
            <div class="total-accumulated-sec mt-4">
                <div class="comon-subhead mt-0">
                    <div class="total-pay-img">
                        <img src="../../../../assets/theme1/pay-img.png" alt="missing"/>
                    </div>
                    <div class="comon-pay-detail">
                        <p>Total</p>
                        <h1>Accumulated Salary</h1>
                    </div>    
                </div>

                  <div class="comon-pay-detail amount-detail">
                        
                        <h1>
                                            @if (isStar) {
                                *****
                                } @else {
                                {{ (userSalaryUpcoming?.earned_salary - userSalaryUpcoming?.deductions?.total_deduction) | number:'1.2-2' }}
                                }
                            <span>/- PKR</span></h1>
                    </div>    

            </div>
            <div class="status-main mt-4">
                <div class="comon-status pendding-status">
                    <p>Pending</p>
                </div>
            </div>
        </div>
    </div>
</div>
}
